module.exports = __webpack_public_path__ + "img/selected6-min.d43ee4c0.png";